(function () {
    'use strict';
    var m = angular.module('utils');
    m.factory('docTitleHelper', ["$route", "$rootScope", "$timeout", "feature", function ($route, $rootScope, $timeout, feature) {
        function getPrefix() {
            if (window.guiVersion != feature.guiVersion) {
                return 'Loading...';
            } else if (feature.checkpointTheme) {
                return 'Check Point SaaS Security';
            } else if (feature.lastlineTheme) {
                return 'Lastline Cloud Security - Powered by Avanan';
            } else if (feature.sonicwallTheme) {
                return 'SonicWall Cloud Application Security';
            } else {
                return 'Avanan';
            }
        }
        feature.init(true, true).then(function () {
            $rootScope.$watch(function () {
                return $route.current && ($route.current.fullTitle || $route.current.title);
            }, function (newVal) {
                if (_(pendingTitle).isNull()) {
                    windowTitleHelper.setTitle('');
                }
            });
        });
        var pendingTitle = null;
        function updateTitle() {
            if (!_(pendingTitle).isNull()) {
                var newTitle = getPrefix();
                if (pendingTitle) {
                    newTitle += ' ' + pendingTitle;
                }
                document.title = newTitle;
                pendingTitle = null;
            }
        }
        var windowTitleHelper = {
            setTitle: function (title) {
                pendingTitle = title;
                $timeout(updateTitle);
            }
        };
        return windowTitleHelper;
    }]);
}());